import { makeStyles } from '@/styles/theme/tss-react';
import { brandColors } from '@/styles/theme/values/brandColors';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'ProductCatalogList',
})(({ spacing, aspectRatio, typography, breakpoints }) => ({
  spacingContainer: {
    background: brandColors.tintsOffWhite60,
    paddingBottom: spacing(3),
    paddingTop: spacing(3),
    [breakpoints.up('md')]: {
      padding: spacing(1),
    },
    '&.darkMode': {
      backgroundColor: brandColors.tintsHeroBlue10,
    },
  },
  cardWrapper: {
    marginTop: spacing(3),
  },
  heading: {
    marginBottom: spacing(0),
    '&.darkMode': {
      color: brandColors.white,
    },
  },
  subhead: {
    '&.darkMode': {
      color: brandColors.white,
    },
  },
  productCard: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    overflow: 'hidden',
  },
  productImageWrapper: {
    width: '100%',
    display: 'flex',
    overflow: 'hidden',
    borderRadius: typography.pxToRem(16),
    aspectRatio: aspectRatio['1/1'],

    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['4/3'],
    },
  },
  productImage: {
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
    transition: 'transform 0.3s ease-in-out',

    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  textContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: spacing(1),
  },
  productTitle: {
    cursor: 'pointer',
    marginBottom: spacing(-1),
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    textDecoration: 'none',
    fontWeight: typography.fontWeightMedium,
    lineHeight: typography.pxToRem(26.4),
    '&:hover': {
      textDecoration: 'underline',
    },
    '&.darkMode': {
      color: brandColors.white,
    },
  },
  productPrice: {
    fontWeight: typography.fontWeightMedium,
    lineHeight: typography.pxToRem(26.4),
    '&.darkMode': {
      color: brandColors.white,
    },
  },
  outOfStockChip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start',
    marginTop: spacing(1),
    padding: `${typography.pxToRem(8)} ${typography.pxToRem(16)}`,
    borderRadius: typography.pxToRem(16),
    backgroundColor: brandColors.tintsHeroBlue90,
    color: brandColors.black,
  },
}));

export default useStyles;
